import React, { useState, useEffect, useCallback } from 'react';
import TableManager from '../data/TableManager';
import { FaTimes } from 'react-icons/fa';

// CONFIURAZIONE CORRETTA: Mantieni tutti i campi ma con visibility appropriate
const fagColumnConfig = [
  // Fields not shown in forms or table (visibility 0) 
  "FAG_Id_FunzioniAggiuntive=0,ID",
  "FAG_IdRif_FunzioniAggiuntive=0,ID Rif.",
  
  // IMPORTANTE: Mantieni questi campi con visibility=0 così il TableManager li conosce
  // ma NewRecordForm non li mostra (filtro automatico su visibility === 1 || 2)
  "FAG_Id_MacroFunzione=0,ID Macro Funzione,readonly", // visibility=0 = nascosto ma necessario per il backend
  "FAG_Id_Funzioni=0,Funzione Collegata,lookupName=funzioniLookup", // visibility=0 = nascosto
  "FAG_TipoApplicativo=0,Tipo Applicativo,required,readonly", // visibility=0 = nascosto ma passato come default, readonly
  
  // General form fields (visibility 2 = form + tabella)
  "FAG_Nome=2,Nome Funzione,required", 
  "FAG_Descrizione=2,Descrizione,required", 
  "FAG_Analisi=2,Analisi", 
  
  // Parameter fields - Nome e Tipo per ogni parametro (visibility 1 = solo form)
  "FAG_NomeParametroIn1=1,Nome P.In1",
  "FAG_TipoParametroIn1=1,Tipo P.In1",
  "FAG_NomeParametroOut1=1,Nome P.Out1",
  "FAG_TipoParametroOut1=1,Tipo P.Out1",
  "FAG_NomeParametroIn2=1,Nome P.In2",
  "FAG_TipoParametroIn2=1,Tipo P.In2",
  "FAG_NomeParametroOut2=1,Nome P.Out2",
  "FAG_TipoParametroOut2=1,Tipo P.Out2",
  "FAG_NomeParametroIn3=1,Nome P.In3",
  "FAG_TipoParametroIn3=1,Tipo P.In3",
  "FAG_NomeParametroOut3=1,Nome P.Out3",
  "FAG_TipoParametroOut3=1,Tipo P.Out3",
  "FAG_NomeParametroIn4=1,Nome P.In4",
  "FAG_TipoParametroIn4=1,Tipo P.In4",
  "FAG_NomeParametroOut4=1,Nome P.Out4",
  "FAG_TipoParametroOut4=1,Tipo P.Out4",
  
  // System fields (visibility 0 = nascosti ma gestiti dal backend)
  "FAG_InizioValidita=0,Inizio Validità,type=datetime,required", 
  "FAG_FineValidita=0,Fine Validità,type=datetime", 
  "FAG_StatiRecord=0,Stato Record,lookupName=statiRecordChar", 

  // Audit fields (visibility 0 = nascosti, gestiti dal backend)
  "FAG_UtenteInserimento=0,Utente Inserimento",
  "FAG_DataOraInserimento=0,Data/Ora Inserimento",
  "FAG_TerminaleInserimento=0,Terminale Inserimento",
  "FAG_UtenteModifica=0,Utente Modifica",
  "FAG_DataOraModifica=0,Data/Ora Modifica",
  "FAG_TerminaleModifica=0,Terminale Modifica",
  "FAG_Utente=0,Utente Audit",
  "FAG_Terminale=0,Terminale Audit",
  "FAG_Timestamp=0,Timestamp DB",
];

// CONFIGURAZIONE LAYOUT: Solo i campi che saranno visibili (visibility=1 o 2)
const fagFormLayoutConfig = {
  sections: [
    {
      title: "Informazioni Generali",
      fields: ["FAG_Nome", "FAG_Descrizione", "FAG_Analisi"] // Solo campi visibili
    },
    {
      title: "Configurazione Parametri",
      layout: "twoColumns",
      columns: [
        {
          title: "Parametri Input",
          icon: "FaArrowLeft",
          fields: [
            ["FAG_NomeParametroIn1", "FAG_TipoParametroIn1"], 
            ["FAG_NomeParametroIn2", "FAG_TipoParametroIn2"], 
            ["FAG_NomeParametroIn3", "FAG_TipoParametroIn3"], 
            ["FAG_NomeParametroIn4", "FAG_TipoParametroIn4"]  
          ]
        },
        {
          title: "Parametri Output", 
          icon: "FaArrowRight",
          fields: [
            ["FAG_NomeParametroOut1", "FAG_TipoParametroOut1"], 
            ["FAG_NomeParametroOut2", "FAG_TipoParametroOut2"], 
            ["FAG_NomeParametroOut3", "FAG_TipoParametroOut3"], 
            ["FAG_NomeParametroOut4", "FAG_TipoParametroOut4"]  
          ]
        }
      ]
    }
  ]
};

// MANTIENI fagLookupConfig e fagInputTypes per i campi nascosti (potrebbero servire al backend)
const fagLookupConfig = {
  funzioniLookup: {
    tableName: 'SKE_Funzioni', 
    valueField: 'FUN_Id_Funzioni', 
    labelField: 'FUN_Nome', 
  },
  statiRecordChar: { 
    options: [
        { value: 'A', label: 'Attivo' },
        { value: 'S', label: 'Sospeso' },
        { value: 'D', label: 'Disattivo' },
    ]
  }
};

const fagInputTypes = {
  // Campi visibili
  FAG_Descrizione: 'text',
  FAG_Analisi: 'richtext', // MODIFICATO: Editor rich text per formattazione HTML
  
  // Parametri
  FAG_NomeParametroIn1: 'text',
  FAG_TipoParametroIn1: 'text',
  FAG_NomeParametroIn2: 'text',
  FAG_TipoParametroIn2: 'text',
  FAG_NomeParametroIn3: 'text',
  FAG_TipoParametroIn3: 'text',
  FAG_NomeParametroIn4: 'text',
  FAG_TipoParametroIn4: 'text',
  FAG_NomeParametroOut1: 'text',
  FAG_TipoParametroOut1: 'text',
  FAG_NomeParametroOut2: 'text',
  FAG_TipoParametroOut2: 'text',
  FAG_NomeParametroOut3: 'text',
  FAG_TipoParametroOut3: 'text',
  FAG_NomeParametroOut4: 'text',
  FAG_TipoParametroOut4: 'text',
  
  // Campi nascosti (per il backend)
  FAG_InizioValidita: 'datetime-local',
  FAG_FineValidita: 'datetime-local',
  FAG_StatiRecord: 'select',
  FAG_Id_Funzioni: 'select',
  FAG_Id_MacroFunzione: 'number',
};

const FunzioniAggiuntiveModal = ({ 
  isOpen, 
  onClose, 
  macroFunzioneId, 
  themeColor = 'emerald',
  onDataChanged,
   macroFunzioneData 
}) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [tipoApplicativo, setTipoApplicativo] = useState('JBE'); // Default: JBE
  
  // Questo useEffect è ancora utile per ricaricare la modale quando viene aperta
  useEffect(() => {
    if (isOpen) {
      setRefreshKey(prev => prev + 1);
    }
  }, [isOpen]);

  // MODIFICATO: Callback per operazioni CRUD - NON per la chiusura
  const handleDataChange = useCallback(() => {
    console.log('🎯 [FunzioniAggiuntiveModal] OPERAZIONE CRUD COMPLETATA! Notifico il parent.');
    if (onDataChanged) {
        console.log('✅ [FunzioniAggiuntiveModal] Chiamando onDataChanged per operazione CRUD...');
        onDataChanged();
    } else {
        console.log('❌ [FunzioniAggiuntiveModal] onDataChanged non disponibile!');
    }
    setRefreshKey(prev => prev + 1);
  }, [onDataChanged]);

  // NUOVO: Handler per la chiusura che NON chiama onDataChanged
  const handleClose = useCallback(() => {
    console.log('🚪 [FunzioniAggiuntiveModal] Chiusura modale - NO operazioni CRUD');
    onClose(); // Chiama solo il callback di chiusura del parent
  }, [onClose]);

  if (!isOpen) return null;

  const initialFiltersForFAG = { 
    FAG_Id_MacroFunzione: macroFunzioneId,
    FAG_TipoApplicativo: tipoApplicativo
  };
  const defaultValuesForCreateFAG = { 
    FAG_Id_MacroFunzione: macroFunzioneId,
    FAG_TipoApplicativo: tipoApplicativo
  };

  // AGGIUNGI: Configurazione filtri vuota per evitare chiamate API non necessarie
  const fagFilterConfig = []; // Vuoto perché non abbiamo filtri specifici per questa tabella

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-75 backdrop-blur-sm p-4">
      <div className={`bg-white dark:bg-gray-800 p-1 sm:p-2 rounded-xl shadow-2xl w-full max-w-6xl border border-${themeColor}-500 dark:border-${themeColor}-700 flex flex-col max-h-[90vh]`}>
        <div className="flex justify-between items-center p-3 border-b border-gray-200 dark:border-gray-700">
          <h3 className={`text-xl font-semibold text-${themeColor}-700 dark:text-${themeColor}-200`}>
            Gestione Funzioni Aggiuntive - {macroFunzioneData?.MAC_Nome ? `${macroFunzioneData.MAC_Nome} (IdRif: ${macroFunzioneId})` : `Macro IdRif: ${macroFunzioneId}`}
          </h3>
          {/* MODIFICATO: Usa handleClose invece di onClose direttamente */}
          <button onClick={handleClose} aria-label="Close modal" className={`p-1 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700`}>
            <FaTimes size={20} />
          </button>
        </div>
        
        {/* Filtro Tipo Applicativo */}
        <div className="p-3 border-b border-gray-200 dark:border-gray-700">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Tipo Applicativo:
          </label>
          <select 
            value={tipoApplicativo}
            onChange={(e) => {
              setTipoApplicativo(e.target.value);
              setRefreshKey(prev => prev + 1); // Refresh per applicare il nuovo filtro
            }}
            className={`w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-${themeColor}-500 focus:border-${themeColor}-500`}
          >
            <option value="JBE">JBE (Java Backend)</option>
            <option value="MIN">MIN (Middleware Node)</option>
          </select>
        </div>
        
        <div className="flex-grow overflow-y-auto p-0 sm:p-2">
          <TableManager
            key={`funzioni-aggiuntive-${macroFunzioneId}-${refreshKey}`}
            tableName="SKE_FunzioniAggiuntive"
            primaryKey="FAG_Id_FunzioniAggiuntive"
            pageTitle=""
            columnConfig={fagColumnConfig}
            filterConfig={fagFilterConfig}
            lookupConfig={fagLookupConfig}
            defaultSortField="FAG_Id_FunzioniAggiuntive"
            defaultSortDirection="desc"
            inputTypes={fagInputTypes}
            initialFilters={initialFiltersForFAG}
            autoSearchOnInitialFilters={true} // ✅ AGGIUNTO: Applica automaticamente i filtri iniziali
            defaultValuesForCreate={defaultValuesForCreateFAG}
            singularRecordName="Funzione Aggiuntiva"
            enableCreate={true}
            enableEdit={true}
            enableDelete={true}
            // NUOVO: Passa la configurazione del layout custom
            formLayoutConfig={fagFormLayoutConfig}
            // MODIFICATO: NON chiamare onDataChanged nei callback per evitare chiusura modale
            onCreateSuccess={() => {
      
              setRefreshKey(prev => prev + 1);
            }}
            onUpdateSuccess={() => {
              console.log('🎯 [FunzioniAggiuntiveModal] UPDATE SUCCESS - refreshing internal data only');
              setRefreshKey(prev => prev + 1);
            }}
            onDeleteSuccess={() => {
              console.log('🎯 [FunzioniAggiuntiveModal] DELETE SUCCESS - refreshing internal data only');
              setRefreshKey(prev => prev + 1);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default FunzioniAggiuntiveModal;